enum CostUnitStatisticGroupEnum {
  ADDITIONAL_COSTS = 'additionalCosts',
  MISCELLANEOUS = 'miscellaneous',
  PAINTING = 'painting',
  SPARE_PARTS = 'spareParts',
  WORK = 'work'
}

export default CostUnitStatisticGroupEnum;
